import Ctrl from 'ctrl.deco';

@Ctrl('/settings/users/add')
class SettingsUsersAddCtrl {
	submitMethod = 'POST';
}
